import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const tTenRoutes = [
    {
        key: "t-ten",
        exact: true,
        path: `${APP_PREFIX_PATH}/t-ten/list`,
        component: React.lazy(() => import("views/app-views/t-ten/pages/TtenList")),
    },
];